<div class="bg-color-sidebar sticky top-0 flex h-screen flex-col">
    <!-- Logo section -->
    <div class="bg-color-sidebar sticky top-0 z-20">
        <div
            class="flex w-full items-center py-2 transition-all"
            [class.justify-center]="isCollapsed()"
            [class.px-6]="!isCollapsed()"
            [class.px-2]="isCollapsed()">
            @if (!isCollapsed()) {
                <a
                    [routerLink]="['/easy/dashboard/home']"
                    class="flex cursor-pointer items-center gap-2">
                    <img
                        src="assets/logo/hairstyleclub-icon.png"
                        class="aspect-square h-10 w-10 shrink-0 object-contain"
                        alt="Hair Style Club" />
                    <span
                        class="text-text-primary text-lg font-bold tracking-tight">
                        Hair Style Club
                    </span>
                </a>
            }
            @if (isCollapsed()) {
                <a
                    [routerLink]="['/easy/dashboard/home']"
                    class="flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center">
                    <img
                        src="assets/logo/hairstyleclub-icon.png"
                        class="aspect-square h-10 w-10 object-contain"
                        alt="Hair Style Club" />
                </a>
            }
        </div>
    </div>

    <!-- Scrollable content -->
    <div class="scrollbar-hide flex-1 overflow-y-auto px-2 pb-4">
        <div class="flex min-h-full flex-col justify-between">
            <div class="mt-2">
                @if (!isCollapsed()) {
                    <ul class="w-56 space-y-1">
                        @for (item of filteredNavigationItems; track $index) {
                            <li>
                                <a
                                    [routerLink]="[item.routerLink]"
                                    routerLinkActive="active"
                                    class="secondary-text text-text-primary hover:bg-primary-soft flex items-center gap-4 rounded-xl px-4 py-2 font-medium">
                                    <span
                                        class="pi {{
                                            item.icon
                                        }} secondary-text text-xl font-semibold text-gray-700"
                                        routerLinkActive="text-white"></span>

                                    <span
                                        fontSpanish
                                        class="text-lg font-medium">
                                        {{ item.label | transloco }}
                                    </span>
                                </a>
                            </li>
                        }
                    </ul>
                } @else {
                    <ul class="space-y-1">
                        @for (item of filteredNavigationItems; track $index) {
                            <li>
                                <a
                                    [routerLink]="[item.routerLink]"
                                    routerLinkActive="active"
                                    class="secondary-text hover:bg-primary-soft flex items-center justify-center rounded-sm px-2 py-3 dark:hover:bg-[#1b1a1a]">
                                    <span
                                        routerLinkActive="text-white"
                                        class="pi {{
                                            item.icon
                                        }} secondary-text text-xl font-semibold text-gray-700"
                                        [pTooltip]="item.label | transloco">
                                    </span>
                                </a>
                            </li>
                        }
                    </ul>
                }
            </div>

            <div class="mt-6 pb-4">
                <span fontSpanish class="text-xs text-gray-400">
                    Version:
                    {{ version() }}
                </span>
            </div>
        </div>
    </div>
</div>
